import React, {useState} from 'react';

import {Link} from 'react-router-dom';

import {connect} from 'react-redux';
import {contractSearch} from "../actions";

const ContractExport = (props) => {

    const [showPayment, setShowPayment] = useState(true);

    return <div className="row">
        <div className="col">
            <div className="row d-print-none">
                <div className="col">
                    <h1><Link to="/contracts" className="ml-2"><i
                        className="fa-light fa-arrow-left small"></i></Link> Kontrakt</h1>
                </div>
                <div className="col text-right">
                    <div className="pt-3">
                        <button onClick={props.onExport} className="btn btn-primary">Exportera</button>
                    </div>
                </div>
            </div>
            <div className="form form-group form-search d-print-none">
                <input type="text" className="form-control" placeholder="Sök på namn, personnr, referens eller plats"
                       value={props.filter && props.filter.search} onChange={props.onSearchChange}/>
            </div>
            <div className="form text-right d-print-none">
                <input type="checkbox"  checked={showPayment} onChange={() => setShowPayment(!showPayment)}/> Visa betalningsinformation
            </div>
            <div className="table-filter d-print-none">
                <ul className="nav nav-tabs mb-0">
                    <li className="nav-item">
                        <a className={ "nav-link " + (props.filter && props.filter.status == -1 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, -1)}>Alla</a>
                    </li>
                    <li className="nav-item">
                        <a className={ "nav-link " + (props.filter && props.filter.status == 0 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 0)}>Obehandlade</a>
                    </li>
                    <li className="nav-item">
                        <a className={ "nav-link " + (props.filter && props.filter.status == 1 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 1)}>Betalda</a>
                    </li>
                    <li className="nav-item">
                        <a className={ "nav-link " + (props.filter && props.filter.status == 2 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 2)}>Arkiverade</a>
                    </li>
                    <li className="nav-item">
                        <a className={ "nav-link " + (props.filter && props.filter.status == 3 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 3)}>Ogiltiga</a>
                    </li>
                </ul>
            </div>
            <table className="contracts-export-table table table-bordered">
                <thead>
                <tr>
                    {showPayment && <th>#</th>}
                    {!showPayment && <th>Referens</th>}
                    {!showPayment && <th>Datum</th>}
                    {!showPayment && <th>Utgår</th>}
                    <th>Personnummer</th>
                    <th>Namn</th>
                    <th>Adress</th>
                    <th>E-post</th>
                    <th>Telefon</th>
                    {showPayment && <>
                    <th>Bank</th>
                    <th>Clearing</th>
                    <th>Kontonummer</th>
                    <th>Kompensation</th></>}
                </tr>
                </thead>
                <tbody>
                {props.contracts && props.contracts.map((contract) => {

                        return <tr>
                            {showPayment && <td>{contract.id}</td>}
                            {!showPayment && <td>{contract.event.title}</td>}
                            {!showPayment &&  <td>{contract.date}</td>}
                            {!showPayment &&  <td>-</td>}
                            <td>{contract.ssn}</td>
                            <td>{contract.name}</td>

                            <td>{contract.address}, {contract.postal_code} {contract.city}</td>
                            <td>{contract.email}</td>
                            <td>{contract.phone}</td>
                            {showPayment && <>
                            <td>{contract.payment.bank}</td>
                            <td>{contract.payment.clearing}</td>
                            <td>{contract.payment.account}</td>
                            <td>{contract.compensation}kr</td></>}
                        </tr>
                })}
                </tbody>
            </table>
        </div>
    </div>


}

export default connect(state => state.contractState, (dispatch) => {
    return {
        onExport: () => {
            window.print();
        },
        onFilterChange: (status, e) => {
            e.preventDefault();
            contractSearch(dispatch, {
                status: status
            });
        },
        onSearchChange: (e) => {
            contractSearch(dispatch, {
                search: e.target.value,
                filter: -1
            });
        }
    }
})(ContractExport)